<template>
  <Video v-if="url" :handleClose="handleClose" :url="url" :appear="true"/>
</template>

<script>

// Components
import Video from './Video'

// Utils
import Utils from '../../../utils/utils'
import MyEmitter from '../../../helpers/MyEmitter'
import params from '../../../utils/params'

export default {
  name: "PageVideoPlayer",
  data() {
    return {
        url: '',
    }
  },
  props: {
    referer: {
      type: String,
      default: null,
    }
  },
  components: {
    Video
  },
  methods: {
    handleClose: function(){

      this.$router.go(-1)
    },
  },  
  async created() {
      const page = await Utils.getFilms()
      
      let film = page.find((item) => item.slug === this.$route.params.slug)
      if(film){
          this.url = film.video
        // set document title
        document.title = film.pageTitle
      } else {
        this.$router.push({path: "error404"})
      }
      MyEmitter.emit(params.Events.appHasLoadedRessources)
  }
}
</script>
